import * as React from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import toast from 'cogo-toast';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Page, Grid, Card, Icon } from 'tabler-react';
import PageComponent from '../PageComponent';
import './account.scss';
import store from '../../shared/store';
import wechat from '../Login/social-wechat.svg';
import Request from '../../shared/request';

class TicketIndex extends PageComponent {
  state = {
    wechatModal: false,
    qrcodeURL: '',
    qrcodeBase64: '',
    UUID: '',
    wechatMessage: '',
  };

  async componentDidMount() {
    await store.dispatch({ type: 'updateUser' });
  }

  saveToken = userInfo => {
    if (userInfo) {
      localStorage.setItem('login', JSON.stringify(userInfo));
      Cookies.set('malus-token', userInfo.token, {
        domain: `.${window.location.host
          .split('.')
          .slice(-2)
          .join('.')}`,
      });
    }
  };

  getUserInfo = async authorizationCode => {
    console.log(authorizationCode);
    const data = await Request.call('bindWechat', {
      authorizationCode,
    });
    if (data && data.token) {
      this.saveToken(data);
      toast.success(`${data.wechatName} 绑定成功`);
      window.location.reload();
      this.setState({ wechatMessage: '', wechatModal: false });
    } else {
      this.setState({ wechatMessage: '', wechatModal: false });
    }
  };

  getCode = async (uuid, time) => {
    const { status, result } = await axios.get(`getWechatCode?uuid=${uuid}&_=${time}`);
    switch (status) {
      case 405:
        // 登陆成功
        this.setState({ wechatMessage: '正在绑定...' });
        this.getUserInfo(result.code);
        break;
      case 404:
        this.setState({ wechatMessage: '手机已扫描' });
        // 继续poll
        setTimeout(() => {
          this.getCode(this.state.UUID, Date.now());
        }, 1000);
        // 扫描成功
        break;
      case 403:
        this.setState({ wechatMessage: '', wechatModal: false });
        toast.warn('绑定已取消');
        // 取消本次登陆
        break;
      case 402:
      case 500:
        this.getUUID();
        // 重新获取uuid
        break;
      case 408:
        // 继续poll
        setTimeout(() => {
          this.getCode(window.wechatUUID, Date.now());
        }, 1000);
        break;
      default:
        break;
    }
  };

  getUUID = async () => {
    this.setState({ wechatModal: true });
    const data = await Request.call('getWechatLoginCode');
    if (data) {
      this.setState({ qrcodeBase64: data.qrcodeURL, UUID: data.UUID });
      this.getCode(this.state.UUID, Date.now());
    }
  };

  render() {
    return (
      <Page.Content className="page-account">
        <Grid.Row>
          <Grid.Col>
            <Card title="账号设置" className="account">
              <div className="body">
                {store.user && !store.user.email ? (
                  <Link to="/dashboard/bind-email" className="item">
                    <div className="label">邮箱账号</div>
                    <div className="right">
                      <div className="btn-bind">立即绑定</div>
                      <i className="fa fa-angle-right" />
                    </div>
                  </Link>
                ) : (
                    <div className="item">
                      <div className="label">邮箱账号</div>
                      <div className="right">{store.user.email}</div>
                    </div>
                  )}

                {store.user && !store.user.phone ? (
                  <Link to="/dashboard/bind-email?tab=phone" className="item">
                    <div className="label">手机账号</div>
                    <div className="right">
                      <div className="btn-bind">立即绑定</div>
                      <i className="fa fa-angle-right" />
                    </div>
                  </Link>
                ) : (
                    <div className="item">
                      <div className="label">手机账号</div>
                      <div className="right">{store.user.phone}</div>
                    </div>
                  )}

                <div className="item">
                  <div className="label">到期时间</div>
                  {store.user && store.user.planExpiredAt === 0 ? (
                    <div className="right">免费用户</div>
                  ) : (
                      <div className="right">
                        {dayjs(store.user.planExpiredAt).format('YYYY.MM.DD')}
                        <span>
                          {store.user.planMode === 'SUBSCRIPTION'
                            ? ' / 连续订阅'
                            : ''}
                        </span>
                      </div>
                    )}
                </div>
                {/* {!store.user.wechatName ? (
                  <div className="item" onClick={this.getUUID}>
                    <div className="label">微信登录</div>
                    <div className="right">
                      <span>立即绑定</span>
                      <i className="fa fa-wechat" />
                      <i className="fa fa-angle-right" />
                    </div>
                  </div>
                ) : (
                    <div className="item">
                      <div className="label">微信登录</div>
                      <div className="right">
                        <span>{`已绑定(${store.user.wechatName})`}</span>
                        <i className="fa fa-wechat" />
                      </div>
                    </div>
                  )} */}
                <PasswordNav />
                {store.user.privcateServer ? (
                  <div className="item">
                    <div className="label">启用合租线路</div>
                    <div className="right">
                      <span>{`${store.user.privcateServer}`}</span>
                    </div>
                  </div>
                ) : (
                    ''
                  )}

                {store.user.clients > 0 ? (
                  <div className="item">
                    <div className="label">可绑定设备</div>
                    <a className="right" href="/dashboard/bind">
                      <span>{`${store.user.clients}`}</span> 台
                      <i className="fa fa-angle-right" />
                    </a>
                  </div>
                ) : (
                    ''
                  )}
              </div>
            </Card>
            <div
              className={`wechat-login ${this.state.wechatModal ? '' : 'hidden'
                }`}>
              <Card className="content">
                <Card.Header>
                  <Card.Title>
                    <img src={wechat} alt="wechat" />
                    绑定微信快捷登录
                  </Card.Title>
                  <div
                    className="closed"
                    onClick={() =>
                      this.setState({ wechatModal: false, wechatMessage: '' })
                    }>
                    <Icon name="x" />
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="qrcode">
                    <img src={this.state.qrcodeBase64} alt="" />
                  </div>
                  <span className="wechat-message">
                    {this.state.wechatMessage}
                  </span>
                </Card.Body>
              </Card>
            </div>
          </Grid.Col>
        </Grid.Row>
      </Page.Content>
    );
  }
}

const PasswordNav = () => {
  if (store.user.needSetPassword && store.user.email) {
    return (
      <Link to="/dashboard/set-password" className="item">
        <div className="label">设置密码</div>
        <div className="right">
          <i className="fa fa-angle-right" />
        </div>
      </Link>
    );
  }
  if (!store.user.needSetPassword && store.user.email) {
    return (
      <Link to="/dashboard/account-password" className="item">
        <div className="label">修改密码</div>
        <div className="right">
          <i className="fa fa-angle-right" />
        </div>
      </Link>
    );
  }
  return <></>;
};

export default TicketIndex;
